<script>
  import classNames from "../../utils/classNames";
  import CustomIcon from "../CustomIcon.svelte";
  import Circle from "svelte-loading-spinners/dist/ts/Circle.svelte";
  import Icon, { Plus, ArrowLeft } from "svelte-hero-icons";
  export let text = "";
  export let buttonIcon = null;
  export let width;
  export let height;
  export let loading = false;
  export let onClick = null;
  export let disabled = false;
  export let className = "";
  export let buttonTheme = "";
  export let submit = null;
  let buttonType;

  if (submit == "true") {
    buttonType = "submit";
  } else {
    buttonType = "button";
  }

  let buttonStyle;

  switch (buttonTheme) {
    case "danger-light":
      buttonStyle = "dangerStyle";
      break;
    case "success-light":
      buttonStyle = "successStyle";
      break;
    case "danger-solid":
      buttonStyle = "dangerSolidStyle";
      break;
    case "success-solid":
      buttonStyle = "successSolidStyle";
      break;
    case "grey-light":
      buttonStyle = "greyStyle";
      break;
    case "grey-solid":
      buttonStyle = "greySolidStyle";
      break;
    case "outline-default":
      buttonStyle = "outlineDefault";
      break;
    case "outline-clear":
      buttonStyle = "outlineTransparent";
      break;
    default:
      buttonStyle = "";
      break;
  }
</script>

<button
  type={buttonType}
  on:click={onClick}
  style="width:{width};height:{height}"
  class={classNames(
    `w-auto h-12 relative inline-flex items-center justify-center p-1 rounded-md border 
    shadow-nv border-custom-orange bg-custom-orange text-sm font-medium text-white 
    hover:bg-custom-orange disabled:opacity-50 focus:z-10 focus:outline-none`,
    className,
    buttonStyle
  )}
  {disabled}
>
  {#if buttonIcon != null}
    {#if buttonIcon == ("plus" || "arrow-left")}
      <Icon
        src={buttonIcon == "plus" ? Plus : ArrowLeft}
        class="mr-2.5 h-5 w-5 text-white outline-none"
        solid
      />
    {:else}
      <CustomIcon
        width={buttonIcon.width || buttonIcon.height || 18}
        height={buttonIcon.height || buttonIcon.width || 18}
        name={buttonIcon.name || buttonIcon}
      />
    {/if}
  {/if}
  {#if loading}
    <Circle color="white" size={16} />
  {:else}
    <span>{text}</span>
  {/if}
</button>

<style>
  .om-button {
    min-width: 5rem;
    padding: 0 10px;
  }

  .dangerStyle {
    background-color: #fff;
    border-color: #ff0000 !important;
    color: #ff0000;
  }

  .successStyle {
    background-color: #fff;
    border-color: #009834 !important;
    color: #009834;
  }

  .dangerSolidStyle {
    background-color: #ff0000;
    border-color: #ff0000 !important;
    color: #fff;
  }
  .outlineTransparent {
    border-color: #f78907 !important;
    color: #f78907;
    background-color: transparent;
  }
  .outlineDefault {
    background-color: #fff;
    border-color: #f78907 !important;
    color: #f78907;
  }

  .successSolidStyle {
    background-color: #009834;
    border-color: #009834 !important;
    color: #fff;
  }

  .greyStyle {
    background-color: #fff;
    border-color: #a4a4a4 !important;
    color: #a4a4a4;
  }

  .greySolidStyle {
    background-color: #a4a4a4;
    border-color: #a4a4a4 !important;
    color: #fff;
  }
</style>
